var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZoomOutMap = function SvgZoomOutMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "zoom_out_map_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#zoom_out_map_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.4 19H8q.424 0 .713.288Q9 19.575 9 20q0 .424-.287.712A.97.97 0 0 1 8 21H4a.97.97 0 0 1-.712-.288A.97.97 0 0 1 3 20v-4q0-.424.288-.713A.97.97 0 0 1 4 15q.424 0 .713.287Q5 15.576 5 16v1.6l2.4-2.4a.95.95 0 0 1 .7-.275q.425 0 .7.275a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7zm11.2 0-2.4-2.4a.95.95 0 0 1-.275-.7q0-.425.275-.7a.95.95 0 0 1 .7-.275q.425 0 .7.275l2.4 2.4V16q0-.424.288-.713A.97.97 0 0 1 20 15q.424 0 .712.287.288.288.288.713v4q0 .424-.288.712A.97.97 0 0 1 20 21h-4a.97.97 0 0 1-.713-.288A.97.97 0 0 1 15 20q0-.424.287-.712A.97.97 0 0 1 16 19zM5 6.4V8q0 .424-.287.713A.97.97 0 0 1 4 9a.97.97 0 0 1-.712-.287A.97.97 0 0 1 3 8V4q0-.424.288-.712A.97.97 0 0 1 4 3h4q.424 0 .713.288Q9 3.575 9 4q0 .424-.287.713A.97.97 0 0 1 8 5H6.4l2.4 2.4a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275zm14 0-2.4 2.4a.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275.95.95 0 0 1-.275-.7q0-.425.275-.7L17.6 5H16a.97.97 0 0 1-.713-.287A.97.97 0 0 1 15 4q0-.424.287-.712A.97.97 0 0 1 16 3h4q.424 0 .712.288Q21 3.575 21 4v4q0 .424-.288.713A.97.97 0 0 1 20 9a.97.97 0 0 1-.712-.287A.97.97 0 0 1 19 8z"
  }))));
};
export default SvgZoomOutMap;